import { render, staticRenderFns } from "./P404.vue?vue&type=template&id=67eefcce&scoped=true"
import script from "./P404.vue?vue&type=script&lang=js"
export * from "./P404.vue?vue&type=script&lang=js"
import style0 from "./P404.vue?vue&type=style&index=0&id=67eefcce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eefcce",
  null
  
)

export default component.exports